import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type RefreshIconProps = CreateIconComponentProps;
export const RefreshIcon: React.FC<RefreshIconProps> = ({
  title = 'Refresh',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      fill="currentColor"
      d="M19.01 11.138a1 1 0 1 0 1.98-.276l-1.98.276ZM3.576 8.615a1 1 0 1 0 1.846.77l-1.846-.77ZM5 5a1 1 0 1 0-2 0h2ZM4 9H3a1 1 0 0 0 1 1V9Zm4 1a1 1 0 0 0 0-2v2Zm12.99.862a9.1 9.1 0 0 0-7.848-7.772l-.256 1.983a7.1 7.1 0 0 1 6.123 6.065l1.982-.276ZM13.143 3.09a9.1 9.1 0 0 0-9.565 5.525l1.846.77a7.1 7.1 0 0 1 7.463-4.312l.256-1.983ZM3 5v4h2V5H3Zm1 5h4V8H4v2ZM4.99 12.862a1 1 0 1 0-1.98.276l1.98-.276Zm15.433 2.523a1 1 0 1 0-1.846-.77l1.846.77ZM19 19a1 1 0 1 0 2 0h-2Zm1-4h1a1 1 0 0 0-1-1v1Zm-4-1a1 1 0 1 0 0 2v-2Zm-12.99-.862a9.1 9.1 0 0 0 7.848 7.772l.256-1.983a7.1 7.1 0 0 1-6.124-6.065l-1.98.276Zm7.848 7.772a9.1 9.1 0 0 0 9.565-5.525l-1.846-.77a7.1 7.1 0 0 1-7.463 4.312l-.256 1.983ZM21 19v-4h-2v4h2Zm-1-5h-4v2h4v-2Z"
    />
  </CreateIconComponent>
);
